import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M8.814 3c-.928 0-1.627-.001-2.264.219a4 4 0 0 0-1.495.923c-.481.472-.794 1.098-1.208 1.928l-2.26 4.521c-.165.328-.289.576-.378.842a4 4 0 0 0-.17.72c-.04.278-.04.48-.039.846 0 0 0 3.712.044 4.253.046.562.145 1.079.392 1.564a4 4 0 0 0 1.748 1.748c.485.247 1.002.346 1.564.392C5.29 21 5.954 21 6.758 21h10.483c.805 0 1.47 0 2.01-.044.563-.046 1.08-.145 1.565-.392a4 4 0 0 0 1.748-1.748c.247-.485.346-1.002.392-1.564.044-.541.044-4.177.044-4.177 0-.367 0-.644-.039-.921a4 4 0 0 0-.17-.721c-.09-.266-.213-.514-.377-.842L20.153 6.07c-.414-.83-.727-1.456-1.208-1.928a4 4 0 0 0-1.495-.923c-.637-.22-1.336-.22-2.264-.22zM7.202 5.11c.279-.097.615-.11 1.765-.11h6.066c1.15 0 1.486.013 1.765.11a2 2 0 0 1 .747.461c.211.207.373.502.887 1.53L20.382 11h-2.264a2.81 2.81 0 0 0-2.512 1.553.81.81 0 0 1-.724.447H9.118a.81.81 0 0 1-.724-.447A2.81 2.81 0 0 0 5.882 11H3.618l1.95-3.9c.514-1.027.676-1.322.887-1.529a2 2 0 0 1 .747-.462M3 13v2.2c0 .857 0 1.439.038 1.889.035.438.1.663.18.819a2 2 0 0 0 .874.874c.156.08.38.145.819.18C5.361 19 5.943 19 6.8 19h10.4c.857 0 1.439 0 1.889-.038.438-.035.663-.1.819-.18a2 2 0 0 0 .874-.874c.08-.156.145-.38.18-.819.037-.45.038-1.032.038-1.889V13h-2.882a.81.81 0 0 0-.724.447A2.81 2.81 0 0 1 14.882 15H9.118a2.81 2.81 0 0 1-2.512-1.553.81.81 0 0 0-.724-.447z",
      clipRule: "evenodd"
    }
  )
);
var SvgInboxBoldOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var InboxBoldOutlined_default = SvgInboxBoldOutlined;

export { InboxBoldOutlined_default as default };
